import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ShapeLineLooseIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="shapeLineLoose" ref={ref} {...props}>
    <path d="M6.33,22.69A.75.75,0,0,1,5.58,22a.74.74,0,0,1,.74-.76,2,2,0,0,0,1.6-.65,2.07,2.07,0,0,0,.41-1.64c-.19-1.34-1.65-2.47-2.21-2.9l-.38-.3a13.6,13.6,0,0,1-3.59-3.6C1,10.22,1,8.31,2.35,7A3.81,3.81,0,0,1,6.6,6.36a9.86,9.86,0,0,1,3.86,3.82l.32.53a17.61,17.61,0,0,0,3.7,4.62c2.12,1.92,3.64,1.46,4.15,1a2.72,2.72,0,0,0,.19-3.2,12.74,12.74,0,0,0-3.15-3.15,15.91,15.91,0,0,1-2.41-2.18C11.38,5.51,11.93,3.5,13,2.46a4.25,4.25,0,0,1,2.68-1.15.75.75,0,1,1,0,1.5A2.73,2.73,0,0,0,14,3.52c-.3.3-1.16,1.43.38,3.27a15.29,15.29,0,0,0,2.19,2,13.75,13.75,0,0,1,3.5,3.55,4.17,4.17,0,0,1-.41,5c-.86.86-3.27,1.78-6.22-.9a18.77,18.77,0,0,1-4-5L9.18,11A8.67,8.67,0,0,0,6,7.73a2.3,2.3,0,0,0-2.59.34c-.8.8-.8,1.95,0,3.23a12.43,12.43,0,0,0,3.23,3.21l.39.3c.68.53,2.5,1.94,2.78,3.88a3.58,3.58,0,0,1-.76,2.83,3.5,3.5,0,0,1-2.73,1.17Z" />
  </Icon>
)) as IconWithRender;

ShapeLineLooseIcon.displayName = 'ShapeLineLooseIcon';
ShapeLineLooseIcon.renderIcon = (props) => <ShapeLineLooseIcon {...props} />;
export default ShapeLineLooseIcon;
